module.exports = __webpack_public_path__ + "static/media/Video overlay.40636619.svg";